import { merge } from 'site-modules/shared/components/lead-form/utils/merge';

import { UnifiedLeadFormCustomConfigDefaultProps } from 'site-modules/shared/components/lead-form/lead-form-prop-types/lead-form-prop-types';
import {
  LF_VIEW_COMPONENT_MAP,
  TY_VIEW_COMPONENT_MAP,
  LF_HEADER_COMPONENT_MAP,
  TY_HEADER_COMPONENT_MAP,
  LF_SUB_HEADER_COMPONENT_MAP,
  TY_SUB_HEADER_COMPONENT_MAP,
  TY_ADS_COMPONENT_MAP,
  LOADING_COMPONENT_MAP,
} from 'site-modules/shared/constants/lead-form/lead-form-templates';

/**
 * Merge default values to config
 * @param {object} config
 * @returns {*}
 */
export function mergeDefaultValuesToCustomConfig(config) {
  const mergeDefaultValues = merge({}, { ...UnifiedLeadFormCustomConfigDefaultProps }, { ...config });
  const {
    loadingComponent,
    leadFormComponent,
    leadFormConfig: {
      headerConfig: { headerComponent: leadFormHeaderComponent, subHeaderComponent: leadFormSubHeaderComponent },
    },
    thankYouComponent,
    thankYouConfig: {
      headerConfig: { headerComponent: thankYouHeaderComponent, subHeaderComponent: thankYouSubHeaderComponent },
      adsConfig: { adComponent: thankYouAdComponent },
    },
    emptyLeadFormComponent,
  } = mergeDefaultValues;

  return merge(mergeDefaultValues, {
    loadingComponent: LOADING_COMPONENT_MAP[loadingComponent] || loadingComponent,
    leadFormComponent: LF_VIEW_COMPONENT_MAP[leadFormComponent] || leadFormComponent,
    leadFormConfig: {
      headerConfig: {
        headerComponent: LF_HEADER_COMPONENT_MAP[leadFormHeaderComponent] || leadFormHeaderComponent,
        subHeaderComponent: LF_SUB_HEADER_COMPONENT_MAP[leadFormSubHeaderComponent] || leadFormSubHeaderComponent,
      },
    },
    thankYouComponent: TY_VIEW_COMPONENT_MAP[thankYouComponent] || thankYouComponent,
    thankYouConfig: {
      headerConfig: {
        headerComponent: TY_HEADER_COMPONENT_MAP[thankYouHeaderComponent] || thankYouHeaderComponent,
        subHeaderComponent: TY_SUB_HEADER_COMPONENT_MAP[thankYouSubHeaderComponent] || thankYouSubHeaderComponent,
      },
      adsConfig: {
        adComponent: TY_ADS_COMPONENT_MAP[thankYouAdComponent] || thankYouAdComponent,
      },
    },
    emptyLeadFormComponent,
  });
}
